import { UserRole } from '@/lib/types/signup-types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SignUpFormData } from 'auth-types';

interface FormState {
  formData: SignUpFormData;
  activeScreen: string;
  submitted: boolean;
}

export const initialState: FormState = {
  formData: {
    firstName: '',
    lastName: '',
    dateOfBirth: undefined,
    learningStyle: [],
    interests: [],
    userRole: UserRole.STUDENT,
  },
  activeScreen: 'roleScreen',
  submitted: false,
};

const signupSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    updateFormData(state: FormState, action: PayloadAction<Partial<SignUpFormData>>) {
      state.formData = { ...state.formData, ...action.payload };
    },
    setActiveScreen(state: FormState, action: PayloadAction<string>) {
      state.activeScreen = action.payload;
    },
    setSubmitted(state: FormState, action: PayloadAction<boolean>) {
      state.submitted = action.payload;
    },
    resetSignUpForm(state: FormState) {
      state = initialState;
    },
  },
});

export const { updateFormData, setActiveScreen, setSubmitted, resetSignUpForm } =
  signupSlice.actions;

export default signupSlice.reducer;
